import React, { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL;
const SITE_URL = "https://www.ahuncycle.com";

const priorityUrls = [
  { loc: "/", priority: "1.0" },
  { loc: "/calendrier", priority: "0.7" },
  { loc: "/medias", priority: "0.7" },
  { loc: "/projets", priority: "0.7" },
  { loc: "/evenements", priority: "0.7" },
  { loc: "/conseils", priority: "0.7" },
  { loc: "/infolettre", priority: "0.7" },
  { loc: "/articles", priority: "0.8" },
  { loc: "/photos", priority: "0.7" },
  { loc: "/videos", priority: "0.7" },
  { loc: "/dons", priority: "0.7" },
  { loc: "/contact", priority: "0.8" }
];

/**
 * Normalise une URL pour éviter les doublons SEO
 */
const normalizeUrl = (url) => {
  let u = url.trim();

  // Force https
  u = u.replace(/^http:\/\//, "https://");

  // Supprime le domaine si présent
  u = u.replace(SITE_URL, "");

  // Supprime paramètres et hash
  u = u.split("?")[0].split("#")[0];

  // Supprime slash final sauf pour la racine
  if (u.length > 1 && u.endsWith("/")) {
    u = u.slice(0, -1);
  }

  return SITE_URL + u;
};

export default function SitemapGenerator() {
  const [sitemap, setSitemap] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await fetch(`${API_URL}/api/articles`);
        const articles = await res.json();

        const urlMap = new Map();

        /* صفحات statiques */
        priorityUrls.forEach((u) => {
          const loc = normalizeUrl(u.loc);

          urlMap.set(loc, {
            loc,
            priority: u.priority,
            lastmod: null
          });
        });

        /* Articles dynamiques */
        articles.forEach((article) => {
          if (!article.href) return;

          const loc = normalizeUrl(article.href);

          // Évite toute collision avec pages statiques
          if (!urlMap.has(loc)) {
            urlMap.set(loc, {
              loc,
              priority: "0.6",
              lastmod: article.updatedAt || article.createdAt
            });
          }
        });

        /* Génération XML propre */
        const urlsXml = Array.from(urlMap.values())
          .map((u) => `
  <url>
    <loc>${u.loc}</loc>
    ${u.lastmod ? `<lastmod>${new Date(u.lastmod).toISOString()}</lastmod>` : ""}
    <priority>${u.priority}</priority>
  </url>`)
          .join("");

        const sitemapXml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urlsXml}
</urlset>`;

        setSitemap(sitemapXml);
      } catch (error) {
        console.error("Erreur sitemap :", error);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Sitemap Generator</h2>
      <p>Copiez ce contenu dans <code>sitemap.xml</code></p>
      <textarea
        style={{ width: "100%", height: "400px" }}
        value={sitemap}
        readOnly
      />
    </div>
  );
}
